// extracted by mini-css-extract-plugin
export var standaloneTable = "_20-0";
export var standaloneTableWithBodyFill = "_20-1";
export var withExtraHeader = "_20-2";